var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-analytics"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('dpr-form')],1),_c('div',{staticClass:"vx-col w-full mb-base"},[_c('dpr-list')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }